import { BiSolidBookContent, BiSolidCategory } from "react-icons/bi";
import { FaHourglassHalf, FaList, FaThLarge } from "react-icons/fa";
import { IoMenuSharp } from "react-icons/io5";
import { MdOutlineProductionQuantityLimits } from "react-icons/md";
import { RxCardStack } from "react-icons/rx";
import { TbCategoryPlus } from "react-icons/tb";
import { TfiLayoutMenuSeparated, TfiLayoutSliderAlt } from "react-icons/tfi";
import { RiCopyrightLine } from "react-icons/ri";
export const initialItems = [
  {
    id: "marqueeMessages",
    type: "marqueeMessages",
    title: "Marquee Messages",
    icon: <FaHourglassHalf />,
    used: 0,
    limit: 1,
  },
  {
    id: "text_Logo_CategoryGroups_SocialMediaIcons",
    type: "text_Logo_CategoryGroups_SocialMediaIcons",
    title: "Text/Logo  + Category Groups + Social Media Icons",
    icon: <FaList />,
    used: 0,
    limit: 100,
  },
  {
    id: "logo_Standard_ECommerce_Opions",
    type: "logo_Standard_ECommerce_Opions",
    title: "Logo + Standard ECommerce Opions",
    icon: <FaThLarge />,
    used: 0,
    limit: 1,
  },
  {
    id: "slider",
    type: "slider",
    title: "Slider",
    icon: <TfiLayoutSliderAlt />,
    used: 0,
    limit: 100,
  },
  {
    id: "categories_with_icons",
    type: "categories_with_icons",
    title: "Categories with Icons",
    icon: <BiSolidCategory />,
    used: 0,
    limit: 100,
  },
  {
    id: "category_Groups_Banner",
    type: "category_Groups_Banner",
    title: "Category Groups Banner",
    icon: <TbCategoryPlus />,
    used: 0,
    limit: 100,
  },
  {
    id: "content_Page",
    type: "content_Page",
    title: "Content Page",
    icon: <BiSolidBookContent />,
    used: 0,
    limit: 100,
  },
  {
    id: "header_menus",
    type: "header_menus",
    title: "Header Menus",
    icon: <TfiLayoutMenuSeparated />,
    used: 0,
    limit: 100,
  },
  {
    id: "footer_menus",
    type: "footer_menus",
    title: "Footer Menus",
    icon: <IoMenuSharp />,
    used: 0,
    limit: 100,
  },
  {
    id: "footer",
    type: "footer",
    title: "Footer",
    icon: <RxCardStack />,
    used: 0,
    limit: 100,
  },
  {
    id: "products",
    type: "products",
    title: "Products",
    icon: <MdOutlineProductionQuantityLimits />,
    used: 0,
    limit: 100,
  },
  {
    id: "footerCopyrights",
    type: "footerCopyrights",
    title: "Footer Copyrights",
    icon: <RiCopyrightLine />,
    used: 0,
    limit: 100,
  },
];
